// Import Sanity client for async operations
import sanityClient from '../sanity/client';

// Toggle Sanity integration
const USE_SANITY = true;

// University configuration with UI-specific data
const universitiesData = {
  'lycee-francais': {
    name: 'High School - Lycée Français de Barcelone',
    slug: 'lycee-francais',
    theme: {
      primary: '#C6007E',
      secondary: '#FF6B9D',
      gradient: 'linear-gradient(135deg, #C6007E 0%, #FF6B9D 100%)'
    },
    content: {
      heroTitle: 'Join our Solo, Duo, Trio or Quadrio Classes!',
      heroSubtitle: 'Learn Now, Excel Tomorrow!',
      heroDescription: 'Interested in joining our classes? Fill out some information and we will be in touch shortly!'
    },
    subjects: [
      { value: "Mathématiques", label: "Mathématiques", calendarVar: "LYCEE_MATHEMATICS_CALENDAR_ID" },
      { value: "Physique-Chimie", label: "Physique-Chimie", calendarVar: "LYCEE_PHYSICS_CALENDAR_ID" },
      { value: "Français", label: "Français", calendarVar: "LYCEE_FRENCH_CALENDAR_ID" },
      { value: "SES", label: "SES", calendarVar: "LYCEE_SES_CALENDAR_ID" },
      { value: "NSI", label: "NSI", calendarVar: "LYCEE_NSI_CALENDAR_ID" },
      { value: "Spanish", label: "Spanish", calendarVar: "LYCEE_SPANISH_CALENDAR_ID" },
      { value: "Catalan", label: "Catalan", calendarVar: "LYCEE_CATALAN_CALENDAR_ID" }
    ],
    tutors: {
      "Mathématiques": [
        { email: "angela_pellon@yahoo.com", name: "Ángela Pellón" },
        { email: "carlota.granados.bcn@gmail.com", name: "Carlota Granados" },
        { email: "clara.bonet@alumni.esade.edu", name: "Clara Bonet" },
        { email: "daniel.anidjar7@gmail.com", name: "Daniel Anidjar" },
        { email: "lunacarrillo05@gmail.com", name: "Luna Carrillo" },
        { email: "natan.viejo@gmail.com", name: "Natan Viejo" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "martifarnell@gmail.com", name: "Martí Farnell Marcet" },
        { email: "tammy.broder@alumni.esade.edu", name: "Tammy Broader" }
      ],
      "Physique-Chimie": [
        { email: "carlota.granados.bcn@gmail.com", name: "Carlota Granados" },
        { email: "lunacarrillo05@gmail.com", name: "Luna Carrillo" }
      ],
      "Français": [
        { email: "angela_pellon@yahoo.com", name: "Ángela Pellón" },
        { email: "clara.bonet@alumni.esade.edu", name: "Clara Bonet" },
        { email: "lunacarrillo05@gmail.com", name: "Luna Carrillo" }
      ],
      "SES": [
        { email: "clara.bonet@alumni.esade.edu", name: "Clara Bonet" },
        { email: "daniel.anidjar7@gmail.com", name: "Daniel Anidjar" },
        { email: "natan.viejo@gmail.com", name: "Natan Viejo" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "martifarnell@gmail.com", name: "Martí Farnell Marcet" },
        { email: "tammy.broder@alumni.esade.edu", name: "Tammy Broader" }
      ],
      "NSI": [
        { email: "martifarnell@gmail.com", name: "Martí Farnell Marcet" }
      ],
      "Spanish": [
        { email: "daniel.anidjar7@gmail.com", name: "Daniel Anidjar" },
        { email: "martifarnell@gmail.com", name: "Martí Farnell Marcet" }
      ],
      "Catalan": [
        { email: "martifarnell@gmail.com", name: "Martí Farnell Marcet" }
      ]
    } 
  },
  'undergraduate': {
    name: 'University - Undergraduate',
    slug: 'undergraduate',
    theme: {
      primary: '#000C40',
      secondary: '#1A237E',
      gradient: 'linear-gradient(135deg, #000C40 0%, #1A237E 100%)'
    },
    content: {
      heroTitle: 'Join our Solo, Duo, Trio or Quadruple Classes!',
      heroSubtitle: 'Excel in Business, Lead Tomorrow!',
      heroDescription: 'Interested in joining our classes? Fill out some information and we will be in touch shortly!'
    },
    subjects: [
      { value: "Applied Mathematics for Management", label: "Applied Mathematics for Management", calendarVar: "APPLIED_MATHEMATICS_CALENDAR_ID" },
      { value: "Descriptive Statistics and Probability", label: "Descriptive Statistics and Probability", calendarVar: "DESCRIPTIVE_STATISTICS_CALENDAR_ID" },
      { value: "Statistical Inference and Data Analysis", label: "Statistical Inference and Data Analysis", calendarVar: "STATISTICAL_INFERENCE_CALENDAR_ID" },
      { value: "Basics of Financial Accounting", label: "Basics of Financial Accounting", calendarVar: "FINANCIAL_ACCOUNTING_BASICS_CALENDAR_ID" },
      { value: "Advanced Accounting", label: "Advanced Accounting", calendarVar: "ADVANCED_ACCOUNTING_CALENDAR_ID" },
      { value: "Microeconomics", label: "Microeconomics", calendarVar: "MICROECONOMICS_CALENDAR_ID" },
      { value: "Macroeconomics", label: "Macroeconomics", calendarVar: "MACROECONOMICS_CALENDAR_ID" },
      { value: "Business Law", label: "Business Law", calendarVar: "BUSINESS_LAW_CALENDAR_ID" },
      { value: "Tax Law", label: "Tax Law", calendarVar: "TAX_LAW_CALENDAR_ID" },
      { value: "Managing Digital Information", label: "Managing Digital Information", calendarVar: "DIGITAL_INFORMATION_CALENDAR_ID" },
      { value: "Information System", label: "Information System", calendarVar: "INFORMATION_SYSTEM_CALENDAR_ID" },
      { value: "Managerial Economics", label: "Managerial Economics", calendarVar: "MANAGERIAL_ECONOMICS_CALENDAR_ID" },
      { value: "Financial Analysis", label: "Financial Analysis", calendarVar: "FINANCIAL_ANALYSIS_CALENDAR_ID" },
      { value: "Financial Economics", label: "Financial Economics", calendarVar: "FINANCIAL_ECONOMICS_CALENDAR_ID" },
      { value: "English", label: "English", calendarVar: "ENGLISH_CALENDAR_ID" },
      { value: "Spanish", label: "Spanish", calendarVar: "SPANISH_CALENDAR_ID" },
      { value: "Catalan", label: "Catalan", calendarVar: "CATALAN_CALENDAR_ID" },
      { value: "German", label: "German", calendarVar: "GERMAN_CALENDAR_ID" }
    ],
    tutors: {
      "Applied Mathematics for Management": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "federico.martino21@gmail.com", name: "Federico Martino" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" },
        { email: "nereamenendezg@gmail.com", name: "Nerea Garcia" },
        { email: "jannat.moufid@alumni.esade.edu", name: "Jannat Moufid" }
      ],
      "Descriptive Statistics and Probability": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" },
        { email: "simon.bahno@gmail.com", name: "Simon Bahno" },
        { email: "gabriella.mccann@icloud.com", name: "Gabriella McCann" }
      ],
      "Statistical Inference and Data Analysis": [
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "marco.morchio0505@gmail.com", name: "Marco Morchio" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" }
      ],
      "Basics of Financial Accounting": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "maximilian.kuehr@gmail.com", name: "Maximilian Kuehr" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" },
        { email: "jannat.moufid@alumni.esade.edu", name: "Jannat Moufid" },
        { email: "naia.olea@alumni.esade.edu", name: "Naia Olea" }
      ],
      "Advanced Accounting": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "maximilian.kuehr@gmail.com", name: "Maximilian Kuehr" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" }
      ],
      "Microeconomics": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "nourbishouty@gmail.com", name: "Nour Bishouty" },
        { email: "federico.martino21@gmail.com", name: "Federico Martino" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "alejandrohernandeza30@gmail.com", name: "Alejandro Hernandez" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "simon.bahno@gmail.com", name: "Simon Bahno" },
        { email: "nereamenendezg@gmail.com", name: "Nerea Garcia" }
      ],
      "Macroeconomics": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "nourbishouty@gmail.com", name: "Nour Bishouty" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "alejandrohernandeza30@gmail.com", name: "Alejandro Hernandez" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" },
        { email: "simon.bahno@gmail.com", name: "Simon Bahno" },
        { email: "jannat.moufid@alumni.esade.edu", name: "Jannat Moufid" }
      ],
      "Business Law": [
        { email: "federico.martino21@gmail.com", name: "Federico Martino" },
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "jannat.moufid@alumni.esade.edu", name: "Jannat Moufid" },
        { email: "naia.olea@alumni.esade.edu", name: "Naia Olea" }
      ],
      "Tax Law": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "federico.martino21@gmail.com", name: "Federico Martino" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "giuseppeleonardo.mazza@alumni.esade.edu", name: "Giuseppe Mazza" },
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "simon.bahno@gmail.com", name: "Simon Bahno" },
        { email: "nereamenendezg@gmail.com", name: "Nerea Garcia" }
      ],
      "Managing Digital Information": [
        { email: "mszeni@yahoo.com", name: "Mark Szeni" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "marco.morchio0505@gmail.com", name: "Marco Morchio" }
      ],
      "Information System": [
        { email: "mszeni@yahoo.com", name: "Mark Szeni" },
        { email: "cire3310@gmail.com", name: "Eric Darasteanu" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" }
      ],
      "Managerial Economics": [
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "federico.martino21@gmail.com", name: "Federico Martino" },
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" },
        { email: "marco.morchio0505@gmail.com", name: "Marco Morchio" },
        { email: "simon.bahno@gmail.com", name: "Simon Bahno" }
      ],
      "Financial Analysis": [
        { email: "Achille.zerbib@gmail.com", name: "Achille Zerbib" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" },
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" },
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "marco.morchio0505@gmail.com", name: "Marco Morchio" },
        { email: "martintuancarrasco@gmail.com", name: "Martin Carrasco" }
      ],
      "Financial Economics": [
        { email: "alessandroromeo554@gmail.com", name: "Alessandro Romeo" },
        { email: "flavia.santi@alumni.esade.edu", name: "Flavia Santi" },
        { email: "alejandrohernandeza30@gmail.com", name: "Alejandro Hernandez" },
        { email: "maximilian.kuehr@gmail.com", name: "Maximilian Kuehr" }
      ],
      "English": [
        { email: "nourbishouty@gmail.com", name: "Nour Bishouty" },
        { email: "giorgio.goretti05@gmail.com", name: "Giorgio Goretti" }
      ],
      "Spanish": [
        { email: "martinkohan81@gmail.com", name: "Martin Kohan" },
        { email: "marcos.delcura@alumni.esade.edu", name: "Marcos del Cura" }
      ],
      "Catalan": [
      ],
      "German": [
        { email: "antoinemuller44@gmail.com", name: "Antoine Muller" },
        { email: "albertomilone8@gmail.com", name: "Alberto Milone" }
      ]
    }
  }
};

// Helper function to get university config by slug
export const getUniversityConfig = (slug) => {
  return universitiesData[slug] || null;
};

// Helper function to get all university slugs
export const getAllUniversitySlugs = () => {
  return Object.keys(universitiesData);
};

// Helper function to check if slug is valid
export const isValidUniversitySlug = (slug) => {
  return slug in universitiesData;
};

/**
 * Get subjects for a university - tries Sanity first, falls back to hardcoded
 * @param {string} universitySlug - University slug (e.g., 'undergraduate', 'lycee-francais')
 * @returns {Promise<Array>} Array of subject objects or strings
 */
export const getSubjectsForUniversity = async (universitySlug) => {
  if (USE_SANITY) {
    try {
      const query = `*[_type == "subject" && university == $university] | order(order asc) { title }`;
      const sanitySubjects = await sanityClient.fetch(query, { university: universitySlug });

      if (sanitySubjects && sanitySubjects.length > 0) {
        console.log(`✅ [SANITY] Fetched ${sanitySubjects.length} subjects for ${universitySlug}`);

        // Remove duplicates (same subject for different years)
        const uniqueSubjects = [];
        const seen = new Set();

        sanitySubjects.forEach(s => {
          if (!seen.has(s.title)) {
            seen.add(s.title);
            uniqueSubjects.push({
              value: s.title,
              label: s.title
            });
          }
        });

        console.log(`📋 [SANITY] Returning ${uniqueSubjects.length} unique subjects (removed ${sanitySubjects.length - uniqueSubjects.length} duplicates)`);
        return uniqueSubjects;
      }
    } catch (error) {
      console.error(`❌ [SANITY] Error fetching subjects for ${universitySlug}:`, error.message);
    }
  }

  // Fallback to hardcoded
  const config = universitiesData[universitySlug];
  if (config && config.subjects) {
    console.log(`📋 [FALLBACK] Using ${config.subjects.length} hardcoded subjects for ${universitySlug}`);
    return config.subjects;
  }
  return [];
};

/**
 * Get tutors for a specific subject - tries Sanity first, falls back to hardcoded
 * @param {string} subject - Subject name
 * @param {string} universitySlug - University slug
 * @returns {Promise<Array>} Array of tutor objects with email and name
 */
export const getTutorsForSubject = async (subject, universitySlug) => {
  if (USE_SANITY) {
    try {
      const query = `*[_type == "tutor" && university == $university && $subject in classes] {
        name,
        email
      }`;
      const sanityTutors = await sanityClient.fetch(query, {
        university: universitySlug,
        subject: subject
      });

      if (sanityTutors && sanityTutors.length > 0) {
        console.log(`✅ [SANITY] Fetched ${sanityTutors.length} tutors for "${subject}" (${universitySlug})`);
        return sanityTutors;
      }
    } catch (error) {
      console.error(`❌ [SANITY] Error fetching tutors for "${subject}":`, error.message);
    }
  }

  // Fallback to hardcoded
  const config = universitiesData[universitySlug];
  if (config && config.tutors && config.tutors[subject]) {
    console.log(`📋 [FALLBACK] Using ${config.tutors[subject].length} hardcoded tutors for "${subject}" (${universitySlug})`);
    return config.tutors[subject];
  }
  return [];
};

/**
 * Get pricing for special packages - tries Sanity first, falls back to hardcoded
 * @param {string} universitySlug - University slug (optional, defaults to 'global')
 * @returns {Promise<Array>} Array of pricing objects
 */
export const getSpecialPackagePricing = async (universitySlug = 'global') => {
  if (USE_SANITY) {
    try {
      // Try to get university-specific pricing first, then fall back to global
      const query = `*[_type == "pricing" && (university == $university || university == "global")] | order(university desc) {
        packageType,
        solo,
        duo,
        trio,
        quadruple,
        university
      }`;
      const sanityPricing = await sanityClient.fetch(query, { university: universitySlug });

      if (sanityPricing && sanityPricing.length > 0) {
        console.log(`✅ [SANITY] Fetched ${sanityPricing.length} pricing entries for ${universitySlug}`);
        return sanityPricing;
      }
    } catch (error) {
      console.error(`❌ [SANITY] Error fetching pricing for ${universitySlug}:`, error.message);
    }
  }

  // Fallback to hardcoded pricing
  console.log(`📋 [FALLBACK] Using hardcoded pricing for special packages`);
  return [
    {
      packageType: '5 hour',
      solo: '125.0 €',
      duo: '195.0 €',
      trio: '220.0 €',
      quadruple: '240.0 €',
      university: 'global'
    },
    {
      packageType: '10 hours',
      solo: '250.0 €',
      duo: '390.0 €',
      trio: '430.0 €',
      quadruple: '470.0 €',
      university: 'global'
    }
  ];
};

export default universitiesData;